<ple-search (searchFieldEventEmitter)="doSearchFilter($event)"></ple-search>
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [style.display]="filterLeafNode(node) ? 'none' : ''" class="asset-tree-node" [class.deviceSelected]="assetTreeService.selectedSiteName === node.siteName">
      <!-- Leaf node -->
      <button mat-icon-button disabled ></button>
    <span (click)="goToDetailPage(node.deviceId, node.orgName, node.siteName)" class="custom-link asset-long-text" [class.customLinkColr]="assetTreeService.selectedSiteName === node.siteName">{{node.siteName}}</span>
    </mat-tree-node>
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [style.display]="filterParentNode(node) ? 'none' : ''" class="asset-tree-node" [class.selected]="assetTreeService.selectedOrgName === node.name">
      <!-- Expandable node -->
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon>
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
      <span class="custom-link-org asset-long-text" (click)="treeControl.toggle(node); getDevicesByOrganization(node.name,node.orgId,true, node)">{{node.name}}</span>
    </mat-tree-node>
  </mat-tree>
  <ng-template #confirmHMIAssetClose>
    <div class="title">
        <h4 mat-dialog-title>Close session</h4>
    </div>
    <hr class="control-command-error-header">
    <mat-dialog-content class="mat-typography command-cotrol-error-dialog">
      <p>Current session will be terminated. Do you want to exit?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close style="height: 35px">No</button>
        <button mat-flat-button mat-dialog-close class="mat-button-primary-sm" (click)="exitFromHMITab()">Yes</button>
    </mat-dialog-actions>
  </ng-template>